export enum PhoneNumberMessagesStatus {
  WAITING_FOR_MESSAGE = 'WAITING_FOR_MESSAGE',
  RECEIVED = 'RECEIVED',
  NOT_RECEIVED = 'NOT_RECEIVED',
}
